"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isParentBindingConstraintsWithServiceId = isParentBindingConstraintsWithServiceId;
const isBindingConstraintsWithServiceId_1 = require("./isBindingConstraintsWithServiceId");
const isParentBindingConstraints_1 = require("./isParentBindingConstraints");
function isParentBindingConstraintsWithServiceId(serviceId) {
    return (0, isParentBindingConstraints_1.isParentBindingConstraints)((0, isBindingConstraintsWithServiceId_1.isBindingConstraintsWithServiceId)(serviceId));
}
//# sourceMappingURL=isParentBindingConstraintsWithServiceId.js.map